// hooks/useLastActive.js
import { useEffect, useCallback } from "react";
import { doc, updateDoc, serverTimestamp } from "firebase/firestore";
import { db, auth } from "../firebase";

export function useLastActive(intervalMs = 5 * 60 * 1000) {
    const uid = auth.currentUser?.uid;
    const userRef = uid && doc(db, "users", uid);

    const ping = useCallback(() => {
        if (userRef) {
            updateDoc(userRef, { lastActive: serverTimestamp() }).catch(console.error);
        }
    }, [userRef]);

    useEffect(() => {
        if (!userRef) return;

        // 1) Initial ping on mount
        ping();

        // 2) Ping whenever tab regains focus
        const onVis = () => { if (!document.hidden) ping(); };
        document.addEventListener("visibilitychange", onVis);

        // 3) Heartbeat every N minutes
        const handle = setInterval(ping, intervalMs);

        return () => {
            document.removeEventListener("visibilitychange", onVis);
            clearInterval(handle);
        };
    }, [ping, intervalMs, userRef]);
}
